<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero"> close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div>
      <v-snackbar
        v-model="snackbar"
        :right="x === 'right'"
        :timeout="timeout"
        :top="y === 'top'"
      >
        {{ errorMsg }}
        <v-btn color="pink" flat @click="snackbar = false"> Close </v-btn>
      </v-snackbar>
    </div>

    <v-toolbar flat color="white">
      <v-toolbar-title>Balance Withdrawal</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="700px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on"
            >New Balance Withdrawal</v-btn
          >
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      v-model="editedItem.amount"
                      label="Amount"
                      :roles="validate_rule"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      v-model="editedItem.account_holder_name"
                      label="Account Holder Name"
                      :roles="validate_rule"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-select
                      v-model="editedItem.withdraw_method_id"
                      :items="indexData.withdrawMethods"
                      label="select withdraw method"
                      item-text="name"
                      item-value="id"
                      :roles="validate_rule"
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      v-model="editedItem.account_number"
                      :roles="validate_rule"
                      label="Account Number"
                    ></v-text-field>
                  </v-flex>

                  <v-flex
                    xs12
                    sm6
                    md6
                    v-if="editedItem.withdraw_method_id == 1"
                  >
                    <v-select
                      v-model="editedItem.bank_id"
                      :items="indexData.banks"
                      label="select a bank"
                      item-text="name"
                      item-value="id"
                      :roles="validate_rule"
                    ></v-select>
                  </v-flex>

                  <v-flex
                    xs12
                    sm6
                    md6
                    v-if="editedItem.withdraw_method_id == 1"
                  >
                    <v-text-field
                      v-model="editedItem.branch_name"
                      :roles="validate_rule"
                      label="Branch Name"
                    ></v-text-field>
                  </v-flex>

                  <v-flex
                    xs12
                    sm6
                    md6
                    v-if="editedItem.withdraw_method_id == 1"
                  >
                    <v-text-field
                      v-model="editedItem.routing_number"
                      :roles="validate_rule"
                      label="Routing Number"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog2" max-width="700px">
        <v-card>
          <v-card-title>
            <span class="headline">Withdraw request detail</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout row>
                <v-flex xs6>
                  <v-subheader class="black--text font-weight-regular"
                    ><b>Amount:</b></v-subheader
                  >
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="black--text font-weight-regular">{{
                    editedItem.amount
                  }}</v-subheader>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6>
                  <v-subheader class="black--text font-weight-regular"
                    ><b>Account holder name:</b></v-subheader
                  >
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="black--text font-weight-regular">{{
                    editedItem.account_holder_name
                  }}</v-subheader>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6>
                  <v-subheader class="black--text font-weight-regular"
                    ><b>Withdraw method name:</b></v-subheader
                  >
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="black--text font-weight-regular">{{
                    editedItem.withdraw_method_name
                  }}</v-subheader>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6>
                  <v-subheader class="black--text font-weight-regular"
                    ><b>Account number:</b></v-subheader
                  >
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="black--text font-weight-regular">{{
                    editedItem.account_number
                  }}</v-subheader>
                </v-flex>
              </v-layout>
              <v-layout row v-if="editedItem.withdraw_method_id == 1">
                <v-flex xs6>
                  <v-subheader class="black--text font-weight-regular"
                    ><b>Bank name:</b></v-subheader
                  >
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="black--text font-weight-regular">{{
                    editedItem.bank_name
                  }}</v-subheader>
                </v-flex>
              </v-layout>
              <v-layout row v-if="editedItem.withdraw_method_id == 1">
                <v-flex xs6>
                  <v-subheader class="black--text font-weight-regular"
                    ><b>Branch name:</b></v-subheader
                  >
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="black--text font-weight-regular">{{
                    editedItem.branch_name
                  }}</v-subheader>
                </v-flex>
              </v-layout>
              <v-layout row v-if="editedItem.withdraw_method_id == 1">
                <v-flex xs6>
                  <v-subheader class="black--text font-weight-regular"
                    ><b>Routing number:</b></v-subheader
                  >
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="black--text font-weight-regular">{{
                    editedItem.routing_number
                  }}</v-subheader>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close2">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="getData"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.index + 1 }}</td>
        <td class="text-xs-center">{{ props.item.amount }}</td>
        <td class="text-xs-center">{{ props.item.account_number }}</td>
        <td class="text-xs-center">{{ props.item.account_holder_name }}</td>
        <td class="text-xs-center">{{ props.item.withdraw_status_name }}</td>
        <td class="text-xs-center">{{ props.item.withdraw_method_name }}</td>
        <!-- <td class="text-xs-center">{{ props.item.password }}</td> -->
        <td class="justify-center layout px-0">
          <v-icon small class="mr-2" @click="editItem(props.item)" v-if="canEditOrDelete(props.item.withdraw_status_id)">
            edit
          </v-icon>
          <v-icon small class="mr-2" @click="showItem(props.item)">
            visibility
          </v-icon>
          <v-icon small @click="deleteItem(props.item)" v-if="canEditOrDelete(props.item.withdraw_status_id)"> delete </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    dialog: false,
    dialog2: false,
    snackbar: false,
    y: "top",
    x: "right",
    timeout: 4000,
    search: "",
    apiUrl: "balance-withdraw-request",
    valid: true,
    headers: [
      {
        text: "Serial No",
        align: "center",
        value: "serial_no",
        sortable: false,
      },
      { text: "Amount", align: "center", value: "amount", sortable: true },
      {
        text: "Account Number",
        align: "center",
        value: "account_number",
        sortable: true,
      },
      {
        text: "Account Holder Name",
        align: "center",
        value: "account_holder_name",
        sortable: true,
      },
      { text: "Status", align: "center", value: "Status", sortable: true },
      {
        text: "Withdraw Method",
        align: "center",
        value: "withdraw_method",
        sortable: true,
      },
      { text: "Actions", align: "center", value: "actions" },
    ],
    editedIndex: -1,
    editedItem: {
      amount: "",
      account_number: "",
      account_holder_name: "",
      withdraw_method_id: "",
      withdraw_method_name: "",
      bank_name: "",
      bank_id: "",
      branch_name: "",
      routing_number: "",
      client_id: "",
    },
    defaultItem: {
      amount: "",
      account_number: "",
      account_holder_name: "",
      withdraw_method_id: "",
      bank_name: "",
      bank_id: "",
      branch_name: "",
      routing_number: "",
      client_id: "",
    },
    validate_rule: [(v) => !!v || "This field is required"],
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "subscriptionData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    formTitle() {
      return this.editedIndex === -1
        ? "New Balance Withdrawal"
        : "Edit Balance Withdrawal";
    },
    getData() {
      if (this.indexData.clientBalanceWithdrawRequests) {
        return this.indexData.clientBalanceWithdrawRequests.data;
      } else {
        return [];
      }
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.$store.dispatch("setIndexData", [this.apiUrl]);
    },

    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },

    editItem(item) {
      this.editedIndex =
        this.indexData.clientBalanceWithdrawRequests.data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    canEditOrDelete(status){
      return status == 1 ? true:false
    },
    showItem(item) {
      this.editedIndex =
        this.indexData.clientBalanceWithdrawRequests.data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog2 = true;
    },

    deleteItem(item) {
      const index =
        this.indexData.clientBalanceWithdrawRequests.data.indexOf(item);
      var result =
        confirm("Are you sure you want to delete this item?") &&
        this.indexData.clientBalanceWithdrawRequests.data.splice(index, 1);
      if (result) {
        this.$store.dispatch("delete", [this.apiUrl, item.id]);
        this.initialize();
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    close2() {
      this.dialog2 = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          this.$store.dispatch("storeOrUpdate", [
            "balance-withdraw-request-update",
            this.editedItem,
          ]);
        } else {
          this.$store.dispatch("storeOrUpdate", [this.apiUrl, this.editedItem]);
        }
        this.snackbar = true;
        this.close();
      }
    },
  },
};
</script>
